import { useSelector } from 'react-redux';
import { isExperimentActive, getParameter } from '../../store/experiments/selectors';
import { ExperimentKeys } from '../ExperimentKeys';
import { EventName } from '../../tracking/EventName';
import { getTracker } from '../../tracking/getTracker';
import { getHasExposureBeenTracked, setHasExposureBeenTracked } from '../useExperiment';
const checkExperimentACQ143Active = state => {
  return isExperimentActive(state, ExperimentKeys.ACQ0143);
};
const checkExperimentACQ143Parameter = state => {
  return getParameter(state, ExperimentKeys.ACQ0143);
};
export const useShouldTrackACQ143 = () => {
  const shouldTrackExposure = useSelector(checkExperimentACQ143Active);
  const parameter = useSelector(checkExperimentACQ143Parameter);
  const trackACQ143Exposure = () => {
    const hasExposureBeenTracked = getHasExposureBeenTracked(ExperimentKeys.ACQ0143);
    if (shouldTrackExposure && !hasExposureBeenTracked) {
      getTracker().track(EventName.ExperimentExposure, {
        action: `${ExperimentKeys.ACQ0143}-group-${parameter}`
      }, true);
      setHasExposureBeenTracked(ExperimentKeys.ACQ0143);
    }
  };
  return {
    trackACQ143Exposure
  };
};
export const trackAcq143ExposureForGooglePrompt = state => {
  const shouldTrackExposure = checkExperimentACQ143Active(state);
  const parameter = checkExperimentACQ143Parameter(state);
  const hasExposureBeenTracked = getHasExposureBeenTracked(ExperimentKeys.ACQ0143);
  if (shouldTrackExposure && !hasExposureBeenTracked) {
    getTracker().track(EventName.ExperimentExposure, {
      action: `${ExperimentKeys.ACQ0143}-group-${parameter}`
    }, true);
    setHasExposureBeenTracked(ExperimentKeys.ACQ0143);
  }
};